import { ComplexContentModel } from '@eag/sales-app-base/build/app/core/rest-api/model/complex-content-model';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { classNames } from 'primereact/utils';

interface Props {
	content: ComplexContentModel;
	className: string;
}

export default function FaqComponent(props: Props) {
	const { content, className } = props;

	return (
		<section className={classNames('login-page-content', className)}>
			<div className={classNames('content-block col-12')}>
				<h6>{content.header}</h6>
				{content.body && <div dangerouslySetInnerHTML={{ __html: content.body }} />}
				<Accordion
					multiple
					transitionOptions={{
						disabled: true,
						addEndListener: () => null,
					}}>
					{content.children?.map((child, index) => (
						<AccordionTab header={child.header} key={index}>
							{child.body && <div dangerouslySetInnerHTML={{ __html: child.body }} />}
						</AccordionTab>
					))}
				</Accordion>
			</div>
		</section>
	);
}
